/**
 * 購入者マイページ注文明細: 顧客用見積書向け郵便番号検索。
 */
import { bindJapanesePostalCodeLookup } from '../share/japanese-postal-code-lookup';

/**
 * @returns {void}
 */
function userOrderDetailBindCustomerPdfPostalLookup() {
    const section = document.getElementById('user-order-customer-estimate-section');
    const postalCodeInput = document.getElementById('user_order_customer_pdf_zip');
    const searchButton = document.getElementById('user_order_customer_pdf_zip_lookup');
    const addressInput = document.getElementById('user_order_customer_pdf_address');

    if (!(section instanceof HTMLElement)) {
        return;
    }
    if (!(postalCodeInput instanceof HTMLInputElement)) {
        return;
    }
    if (!(searchButton instanceof HTMLButtonElement)) {
        return;
    }
    if (!(addressInput instanceof HTMLInputElement)) {
        return;
    }

    const postalLookupErrorMessage = section.dataset.postalLookupErrorMessage ?? '';

    bindJapanesePostalCodeLookup({
        postalCodeInput,
        searchButton,
        onResolved(lookupResult) {
            if (typeof window.jpenergyClearClientBlockMessages === 'function') {
                window.jpenergyClearClientBlockMessages();
            }

            addressInput.value = lookupResult.fullAddress;
        },
        onRequestError() {
            if (
                typeof window.jpenergyShowClientBlockMessage === 'function'
                && postalLookupErrorMessage !== ''
            ) {
                window.jpenergyShowClientBlockMessage('warning', postalLookupErrorMessage);
            }
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    userOrderDetailBindCustomerPdfPostalLookup();
});
